/**
 * Triggers 命名空间
 */
export const triggersNamespace = 'fanfanlo/javajs/v1/project/components/triggers/'
